export default __webpack_public_path__ + "static/play-e61f64655d1cae627a2bc9484ec2a0b8.gif";